// @ts-nocheck
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./polyfill";
import "./assets/js/bootstrap.js";
// import cssVars from 'css-vars-ponyfill'
import { Switch } from "@coreui/vue";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import BootstrapVue from "bootstrap-vue";
import OneSignalVue from "onesignal-vue";
import Vodal from "vodal";
import Vue from "vue";
import CheckboxRadio from "vue-checkbox-radio";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import FullScreen from "vue-fullscreen";
import VueI18n from "vue-i18n";
import ToggleButton from "vue-js-toggle-button";
import VueMobileDetection from "vue-mobile-detection";
import Multiselect from "vue-multiselect";
import { ClientTable, ServerTable } from "vue-tables-2";
import Toast from "vue-toastification";
import Vuelidate from "vuelidate";
import AppSetting from "../AppSetting.json";
import Authorize from "../src/shared/authorization/authorize";
import TextEditor from "../src/widgets/form/TextEditor";
import App from "./App.vue";
import example from "./assets/js/Example.vue";
import flipBook from "./assets/js/FlipBook.vue";
import messages from "./lang";
import router from "./router/index";
import { initS3Client } from "./shared/aws";
import filters from "./shared/vue-filters";
import { store } from "./store";

Vue.use(CheckboxRadio);
Vue.component("TextEditor", TextEditor);
Vue.component("tags-input", VoerroTagsInput);

Vue.use(ToggleButton);
Vue.use(FullScreen);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.use(Toast);
Vue.component(Vodal.name, Vodal);
Vue.use(BootstrapVue);
Vue.use(ClientTable);
Vue.use(ServerTable);
Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(VueMobileDetection);
Vue.component("multiselect", Multiselect);
Vue.component("c-switch", Switch);
Vue.filter("toTime", value => filters.getToTimeVueFilter(value));

Vue.component("flip", flipBook);
Vue.component("example", example);

Vue.use(OneSignalVue);

export const i18n = new VueI18n({
  locale: "tr-TR",
  fallbackLocale: "tr-TR",
  messages,
  silentTranslationWarn: true,
});

Vue.prototype.$s3 = initS3Client();

Vue.prototype.$appSetting = AppSetting;
Vue.prototype.$auth = Authorize;
// Vue.config.devtools = true
// Vue.config.performance = true
/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  el: "#app",
  router,
  store,
  i18n,
  template: "<App/>",
  components: {
    App,
  },
  beforeMount() {
    // do nothing
  },
});
